// extracted by mini-css-extract-plugin
export default {"root":"TechnicalDetails_root__UJXmB"};